import clsx from 'clsx';
import type { FC, ReactNode } from 'react';
import { createPortal } from 'react-dom';

const modal = document.getElementById('modal');

interface ModalProps {
	isOpened: boolean;
	children?: ReactNode;
	className?: string;
}

export const Modal: FC<ModalProps> = ({ isOpened, children, className }) =>
	isOpened && modal
		? createPortal(
				<div className="fixed w-full h-full top-0 left-0 flex items-center justify-center overflow-y-auto bg-neutral-950/80 px-space-16 pt-[88px] pb-space-16 md:py-space-16">
					<div
						className={clsx(
							'bg-white space-y-4 rounded-md p-space-32 max-w-90 my-auto max-h-full overflow-y-auto',
							className,
						)}
					>
						{children}
					</div>
				</div>,
				modal,
			)
		: null;
